import React, { useState } from 'react';
import {
  TextField, Button, Grid, Typography, RadioGroup, FormControlLabel,
  Radio, FormControl, FormLabel, FormHelperText, Box, Checkbox
} from '@mui/material';
import PdfModalViewer from './PdfModalViewer';
import { useValidatedDetailChange } from './common/useValidatedDetailChange';
import { intValidator, decimalValidator } from './common/validators';
const Comp2Sub = ({formData , setSubmitErrors, setFormData, mypageData, sameAsExhibitor, setSameAsExhibitor, fieldsDisabled, setFieldsDisabled, sameAsCertExhibitor, setSameAsCertExhibitor, fieldsCertDisabled, setFieldsCertDisabled, sameAsCertExhibitor2, setSameAsCertExhibitor2, fieldsCertDisabled2, setFieldsCertDisabled2, submitErrors, corrections, changeModalOpen, handleCorrectionChange, detailErrors, setDetailErrors,otherMethod,handleOtherMethodChange,handleMethodChange}) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };
  const vehicleTypes = [
    "mini",
    "norm",
    "big",
    "trail",
    "crain",
    "fork",
    "other"
  ];
  const handleVehicleNumChange = (carKind, value, target) => {
    const num = Number(value) || 0;
    const key =
        target === "cert"
        ? "cert_details"
        : "indoor_details";
    setFormData((prev)=>{
        const oldList = prev[key] || [];
        // 既存の同じ車種
        const current =
        oldList.filter(
            item => item.car_kind === carKind
        );
        let newList = [...oldList];
        if(num > current.length){
        // 足りない分追加
        const addCount = num - current.length;
        for(let i=0;i<addCount;i++){
            newList.push({
            car_kind:carKind,
            cert_comp:"",
            cert_user:"",
            cert_phone:""
            });
        }
        }else{
        // 超過分削除
        let removeCount =
            current.length - num;
        for(
            let i=newList.length-1;
            i>=0 && removeCount>0;
            i--
        ){
            if(newList[i].car_kind === carKind){
            newList.splice(i,1);
            removeCount--;
            }
        }
        }
        return {
        ...prev,
        [key]:newList
        }
    });
  };
  const handleCarDetailChange = (
    index,
    field,
    value,
    target
    )=>{
    const key =
    target==="cert"
    ? "cert_details"
    : "indoor_details";
    setFormData(prev=>({
    ...prev,
    [key]:
    prev[key].map((item,i)=>
    i===index
    ? {
        ...item,
        [field]:value
    }
    : item
    )
    }));
  };
  console.log(formData)

  const handleSameAsCertExhibitor = (value) => {
    setSameAsCertExhibitor(value);

    if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
        ...prev,
        cert_comp: mypageData.company_name || "",
        cert_user: mypageData.user_name || "",
        cert_phone: mypageData.phone_number || "",
        }));
        setFieldsCertDisabled(true);
    } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
        ...prev,
        cert_comp: "",
        cert_user: "",
        cert_phone: "",
        }));
        setFieldsCertDisabled(false);
    }
  };

  const handleSameAsCertExhibitor2 = (value) => {
    setSameAsCertExhibitor2(value);

    if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
        ...prev,
        cert_2_comp: mypageData.company_name || "",
        cert_2_user: mypageData.user_name || "",
        cert_2_phone: mypageData.phone_number || "",
        }));
        setFieldsCertDisabled2(true);
    } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
        ...prev,
        cert_2_comp: "",
        cert_2_user: "",
        cert_2_phone: "",
        }));
        setFieldsCertDisabled2(false);
    }
  };

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
        ...prev,
        user_2_name: mypageData.user_name || "",
        user_2_department: mypageData.department || "",
        user_2_phone: mypageData.phone_number || "",
        user_2_tel: mypageData.tel_number || "",
        }));
        setFieldsDisabled(true);
    } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
        ...prev,
        user_2_name: "",
        user_2_department: "",
        user_2_phone: "",
        user_2_tel: "",
        }));
        setFieldsDisabled(false);
    }
  };

    const handleDetailChange = useValidatedDetailChange(
    setFormData,
    setDetailErrors
    );

    const addDetail = () => {
        const newDetails = [
            ...formData.details,
            { exhibition: '', number: 0, weight: 0, length: 0, width: 0, height: 0 },
        ];
        setFormData({ ...formData, details: newDetails });
        setDetailErrors((prev) => [
            ...prev,
            { number: "", weight: "", length: "", width: "", height: "" },
        ]);
    };

    const removeDetail = (index) => {
        const newDetails = formData.details.filter((_, i) => i !== index);
        setFormData({ ...formData, details: newDetails });
    };

  const [open , setOpen] = useState(false);
  return (
    <>
    <Box sx={{ p:{xs: 0, md: 2} }}>
        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].user_2_info}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                onChange={handleCorrectionChange('r2', 'user_2_info')}
            />
            }
            label="担当者情報"
        />
        )}
        <Typography variant="h6" gutterBottom className='f-16'>担当者情報</Typography>
        <Typography color="error" className='info'>※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
        <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend" className='info'>出展申込時の担当者と</FormLabel>
            <RadioGroup
            row
            value={sameAsExhibitor}
            onChange={(e) => handleSameAsExhibitor(e.target.value)}
            >
            <FormControlLabel value="same" control={<Radio />} label="同じ" />
            <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
        </FormControl>
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" name="user_2_name" value={formData.user_2_name} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_name} helperText={submitErrors.user_2_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" name="user_2_department" value={formData.user_2_department} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_department} helperText={submitErrors.user_2_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" name="user_2_phone" value={formData.user_2_phone} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_phone} helperText={submitErrors.user_2_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" name="user_2_tel" value={formData.user_2_tel} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_tel} helperText={submitErrors.user_2_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        </Grid>
        <Typography color="error" className='info'>※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

        {/* <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>搬入・搬出方法</Typography>
        <Typography color="error" className='info'>現在予定している搬入・搬出方法を出展の手引きp.9～p.15を参照にご選択ください。</Typography>
        <Box>
            <Button variant="outlined" onClick={() => setOpen(true)}>出展の手引き該当ページを表示する</Button>
        </Box>
        <PdfModalViewer
            filePath="/しんきんビジネスフェア2026-出展の手引き.pdf"
            isOpen={open}
            onClose={() => setOpen(false)}
            startPage={10}
            endPage={16}
        />
        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].method}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                onChange={handleCorrectionChange('r2', 'method')}
            />
            }
            label="搬入出方法選択"
        />
        )} */}
        <Grid container spacing={2}>
            {/* 方法選択（ラジオ） */}
            {/* <Grid size={12}>
            <FormControl fullWidth error={!!submitErrors.method}>
                <RadioGroup
                name="method"
                value={
                    formData.method.startsWith('その他｜')
                    ? 'その他'
                    : formData.method
                }
                onChange={handleMethodChange}
                >
                <FormControlLabel value="運送会社活用パターン" control={<Radio />} label="運送会社活用パターン" />
                <FormControlLabel value="周辺駐車場活用パターン" control={<Radio />} label="周辺駐車場活用パターン" />
                <FormControlLabel value="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン" control={<Radio />} label="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン" />
                <FormControlLabel value="その他" control={<Radio />} label="その他" />
                </RadioGroup>
                {formData.method.startsWith('その他｜') && (
                <TextField
                    fullWidth
                    label="その他内容"
                    value={otherMethod}
                    onChange={handleOtherMethodChange}
                    margin="normal"
                />
                )}
                {submitErrors.method && <FormHelperText sx={{color:'#f10a0a', fontWeight: 'bold'}}>{submitErrors.method}</FormHelperText>}
            </FormControl>
            </Grid>
            <Typography color='error' className='info'>
                【注意】<br />
                ※展示館内及び展示館ローディングヤードへの車両乗り入れが必要な場合を除き、原則、運送会社・周辺駐車場をご活用ください。<br />
                ※展示館内及び展示館ローディングヤード乗入れが必要な場合、周辺の乗入れ場所に限りがあるため、展示館周辺に来るまでにかなりの混雑が想定されます。予めご了承ください。
            </Typography> */}

            {!!changeModalOpen &&(
            <FormControlLabel
                control={
                <Checkbox
                    checked={corrections.r2[0].date}
                    onChange={handleCorrectionChange('r2', 'date')}
                    sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                />
                }
                label="搬入出予定日"
            />
            )}

            {/* 搬入希望日選択（ラジオ） */}
            <Grid size={12}>
            <FormControl error={!!submitErrors.reserve_date}>
            <Typography variant="h6" className='f-16'>搬入予定日</Typography>

            <RadioGroup
                name="reserve_date"
                value={formData.reserve_date}
                onChange={(e) =>
                setFormData({
                    ...formData,
                    reserve_date: e.target.value,
                    // 11/3 or 11/4選んだらother_detail消す
                    other_detail:
                    e.target.value === "other" ? formData.other_detail : "",
                })
                }
                row
            >
                <FormControlLabel
                value="11/11"
                control={<Radio />}
                label="11月11日（水）"
                />

                <FormControlLabel
                value="11/12"
                control={<Radio />}
                label="【当日】11月12日（木）"
                />

                {/* <FormControlLabel
                value="other"
                control={<Radio />}
                label="その他"
                /> */}
            </RadioGroup>

            {/* 🔥 その他選択時だけ表示 */}
            {formData.reserve_date === "11/12" && (
                // <TextField
                // fullWidth
                // margin="normal"
                // label="詳細を入力してください"
                // value={formData.reserve_detail}
                // onChange={(e) =>
                //     setFormData({
                //     ...formData,
                //     reserve_detail: e.target.value,
                //     })
                // }
                // />
                <Typography color="error" className='f-16'>
                    【注意】<br />
                    ●当日搬入作業時間　11月12日（木） 7:30～8:30<br />
                    ●搬入出駐車場使用時間　11月12日（木） 7:00～9:00<br />
                    ※搬入終了後は速やかに有料駐車場へ移動してください。<br />
                    ※9:00以降、搬入出駐車場は閉鎖になります。そのまま駐車した場合、特別駐車料金［5,000円（税込）］が発生しますのでご注意ください。
                </Typography>
            )}

            {submitErrors.reserve_date && (
                <FormHelperText>{submitErrors.reserve_date}</FormHelperText>
            )}
            </FormControl>
            </Grid>
            </Grid>

        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].cars}
                onChange={handleCorrectionChange('r2', 'cars')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
            />
            }
            label="搬入出車両証"
        />
        )}

        <Grid container spacing={2}>
            <Grid size={12}>
            <FormControl error={!!submitErrors.car_certification}>
                <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>
                    搬入出車両証
                </Typography>
                <RadioGroup
                    row
                    name="car_certification"
                    value={formData.car_certification ? 'true' : 'false'}
                    onChange={(e)=>{
                        const value = e.target.value === 'true';
                        setFormData({
                            ...formData,
                            car_certification:value,
                            ...(value
                            ? {}
                            : {
                                cert_details:[]
                            })
                        });
                    }}
                >
                <FormControlLabel value="true" control={<Radio />} label="申請する" />
                <FormControlLabel value="false" control={<Radio />} label="申請しない" />
                </RadioGroup>
                {submitErrors.car_certification &&
                <FormHelperText>
                    {submitErrors.car_certification}
                </FormHelperText>}
            </FormControl>
            </Grid>
        </Grid>
        {formData.car_certification && (
        <>
        <Grid container spacing={2}>
            <Typography color="error" className='info'>
            ※搬入出の際に使用する車両台数を入力してください。
            </Typography>
            {
            [
            {
                label:"小型車（2tクラス以下）",
                kind:"mini"
            },
            {
                label:"中型車（4tクラス以下）",
                kind:"norm"
            },
            {
                label:"大型車（10tクラス以下）",
                kind:"big"
            },
            {
                label:"トレーラー（コンテナを含む）",
                kind:"trail"
            },
            {
                label:"クレーン",
                kind:"crain"
            },
            {
                label:"フォークリフト",
                kind:"fork"
            },
            {
                label:"その他台数",
                kind:"other"
            }
            ].map(({label, kind}) => (
            <Grid
            size={{xs:12,sm:6}}
            key={kind}
            >
            <TextField
            fullWidth
            label={label}
            value={
            formData.cert_details.filter(
            x=>x.car_kind===kind
            ).length
            }
            onChange={(e)=>
            handleVehicleNumChange(
            kind,
            e.target.value,
            "cert"
            )
            }
            />
            </Grid>
            ))}
        </Grid>
        {/* <FormControl component="fieldset" sx={{mt:2}}>
        <FormLabel component="legend" className='info'>
        出展申込時の担当者と
        </FormLabel>
        <RadioGroup
        row
        value={sameAsCertExhibitor}
        onChange={(e)=>
        handleSameAsCertExhibitor(e.target.value)
        }
        >
        <FormControlLabel value="same" control={<Radio/>} label="同じ"/>
        <FormControlLabel value="different" control={<Radio/>} label="異なる"/>
        </RadioGroup>
        </FormControl> */}
        <Typography color="error" className='info'>
        ※搬入出車両証を申請する場合は運転者情報を入力してください。
        </Typography>
        {
        formData.cert_details.map((item,index)=>(
        <Grid container spacing={2} key={index}>
        <Grid size={{xs:12}}>
        <Typography variant="subtitle1">
        車両 {index+1}
        （{item.car_kind}）
        </Typography>
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="会社名"
        value={item.cert_comp}
        disabled={fieldsCertDisabled}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_comp",
        e.target.value,
        "cert"
        )
        }
        />
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="氏名"
        value={item.cert_user}
        disabled={fieldsCertDisabled}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_user",
        e.target.value,
        "cert"
        )
        }
        />
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="携帯電話番号"
        value={item.cert_phone}
        disabled={fieldsCertDisabled}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_phone",
        e.target.value,
        "cert"
        )
        }
        />
        </Grid>
        </Grid>
        ))
        }
        </>
        )}

        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].cars}
                onChange={handleCorrectionChange('r2', 'cars')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
            />
            }
            label="車両乗り入れ"
        />
        )}

        <Grid container spacing={2}>
            <Grid size={12}>
            <FormControl error={!!submitErrors.indoor_car}>
                <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>展示館内への車両乗り入れ</Typography>
                <RadioGroup
                    row
                    name="indoor_car"
                    value={formData.indoor_car ? 'true' : 'false'}
                    onChange={(e) => {
                        const value = e.target.value === 'true';
                        if (!value) {
                        // false のとき関連項目をリセット
                        setFormData({
                            ...formData,
                            indoor_car: false,
                            mini_num: null,
                            norm_num: null,
                            big_num: null,
                            trail_num: null,
                            crain_num: null,
                            fork_num: null,
                            other_num: null,
                            other_detail: "",
                        });
                        } else {
                        setFormData({ ...formData, indoor_car: true });
                        }
                    }}
                >
                <FormControlLabel value="true" control={<Radio />} label="申請する" />
                <FormControlLabel value="false" control={<Radio />} label="申請しない" />
                </RadioGroup>
                {submitErrors.indoor_car && <FormHelperText>{submitErrors.indoor_car}</FormHelperText>}
            </FormControl>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
        {formData.indoor_car && (
        <>
        {/* <FormControl component="fieldset" sx={{mt:2}}>
        <Typography variant='h6' className='f-16'>
        運転者情報
        </Typography>
        <FormLabel component="legend" className='info'>
        出展申込時の担当者と
        </FormLabel>
        <RadioGroup
        row
        value={sameAsCertExhibitor2}
        onChange={(e)=>
        handleSameAsCertExhibitor2(e.target.value)
        }
        >
        <FormControlLabel
        value="same"
        control={<Radio/>}
        label="同じ"
        />
        <FormControlLabel
        value="different"
        control={<Radio/>}
        label="異なる"
        />
        </RadioGroup>
        </FormControl> */}
        <Typography color="error" className='info'>
        ※展示館内へ乗入れる車両台数を入力してください。
        </Typography>
        {
        [
        {
            label:"小型車（2tクラス以下）",
            kind:"mini"
        },
        {
            label:"中型車（4tクラス以下）",
            kind:"norm"
        },
        {
            label:"大型車（10tクラス以下）",
            kind:"big"
        },
        {
            label:"トレーラー（コンテナを含む）",
            kind:"trail"
        },
        {
            label:"クレーン",
            kind:"crain"
        },
        {
            label:"フォークリフト",
            kind:"fork"
        },
        {
            label:"その他台数",
            kind:"other"
        }
        ].map(({label, kind}) => (
        <Grid
        size={{xs:12,sm:6}}
        key={kind}
        >
        <TextField
        fullWidth
        label={label}
        value={
        formData.indoor_details.filter(
        x=>x.car_kind===kind
        ).length
        }
        onChange={(e)=>
        handleVehicleNumChange(
        kind,
        e.target.value,
        "indoor"
        )
        }
        />
        </Grid>
        ))}
        {
        formData.indoor_details.map((item,index)=>(
        <Grid container spacing={2} key={index}>
        <Grid size={{xs:12}}>
        <Typography>
        車両 {index+1}
        （{item.car_kind}）
        </Typography>
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="会社名"
        value={item.cert_comp}
        disabled={fieldsCertDisabled2}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_comp",
        e.target.value,
        "indoor"
        )
        }
        />
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="氏名"
        value={item.cert_user}
        disabled={fieldsCertDisabled2}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_user",
        e.target.value,
        "indoor"
        )
        }
        />
        </Grid>
        <Grid size={{xs:12,sm:6}}>
        <TextField
        fullWidth
        label="携帯電話番号"
        value={item.cert_phone}
        disabled={fieldsCertDisabled2}
        onChange={(e)=>
        handleCarDetailChange(
        index,
        "cert_phone",
        e.target.value,
        "indoor"
        )
        }
        />
        </Grid>
        </Grid>
        ))
        }
        </>
       )}
       </Grid>
        
        
        <>
        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].exhibits}
                onChange={handleCorrectionChange('r2', 'exhibits')}
                sx={{
        color: 'red', // 未チェック時の枠の色
        '&.Mui-checked': {
        color: 'red', // チェック時の色
        },
    }}
            />
            }
            label="出展物"
        />
        )}
        <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>出展物の詳細</Typography>
        <Typography color='error' className='info'>主な出展物のおおよそ重量・寸法をご入力ください。<br />※2つ目以降の出展物を入力される場合は「出展物を追加」をご選択ください。</Typography>
        {formData?.details?.map((detail, index) => (
        <Grid key={index} sx={{ mb: 2, pl: 2 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    label="展示物名"
                    value={detail.exhibition}
                    onChange={(e) => {
                    const value = e.target.value;
                    setFormData((prev) => {
                        const details = [...prev.details];
                        details[index] = {
                        ...details[index],
                        exhibition: value,
                        };
                        return { ...prev, details };
                    });
                    }}
                    error={!!submitErrors.details}
                    helperText={index === 0 && submitErrors.details ? submitErrors.details : ""}
                />
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                <TextField
                    fullWidth
                    label="個数"
                    value={detail.number}
                    onChange={handleDetailChange(
                    index,
                    "number",
                    intValidator({ allowMinus: false, label: "個数" })
                    )}
                    error={!!detailErrors[index]?.number || !!submitErrors.details}
                    helperText={
                    detailErrors[index]?.number ||
                    (index === 0 ? submitErrors.details : "")
                    }
                />
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                <TextField
                    fullWidth
                    label="重量(kg)"
                    value={detail.weight}
                    onChange={handleDetailChange(
                    index,
                    "weight",
                    decimalValidator({ scale: 2, label: "重量" })
                    )}
                    error={!!detailErrors[index]?.weight || !!submitErrors.details}
                    helperText={
                    detailErrors[index]?.weight ||
                    (index === 0 ? submitErrors.details : "")
                    }
                />
                </Grid>
            </Grid>

            {/* 下段 */}
            <Grid container spacing={2} sx={{ mt: 1 }} alignItems="center">
                <Grid size={{ xs: 12, sm: 3 }}>
                <TextField
                    fullWidth
                    label="長(mm)"
                    value={detail.length}
                    onChange={handleDetailChange(
                    index,
                    "length",
                    decimalValidator({ scale: 2, label: "長さ" })
                    )}
                    error={!!detailErrors[index]?.length}
                    helperText={detailErrors[index]?.length}
                />
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                <TextField
                    fullWidth
                    label="幅(mm)"
                    value={detail.width}
                    onChange={handleDetailChange(
                    index,
                    "width",
                    decimalValidator({ scale: 2, label: "幅" })
                    )}
                    error={!!detailErrors[index]?.width}
                    helperText={detailErrors[index]?.width}
                />
                </Grid>

                <Grid size={{ xs: 12, sm: 3 }}>
                <TextField
                    fullWidth
                    label="高さ(mm)"
                    value={detail.height}
                    onChange={handleDetailChange(
                    index,
                    "height",
                    decimalValidator({ scale: 2, label: "高さ" })
                    )}
                    error={!!detailErrors[index]?.height}
                    helperText={detailErrors[index]?.height}
                />
                </Grid>

                {/* 削除ボタン */}
                <Grid size={{ xs: 12, sm: 3 }} sx={{ textAlign: "right" }}>
                {formData?.details?.length >= 1 && (
                    <Button
                    variant="outlined"
                    color="error"
                    onClick={() => removeDetail(index)}
                    >
                    削除
                    </Button>
                )}
                </Grid>
            </Grid>

            </Grid>
        ))}
        <Button variant="contained" onClick={addDetail}>出展物を追加</Button>
        </>

        <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>備考欄</Typography>
        <Typography color="error" className='info'>※搬入・搬出について補足事項等がある場合はコチラにご入力ください。</Typography>
        <TextField
            fullWidth
            multiline
            rows={4}
            label="備考"
            name="alfa_text"
            value={formData.alfa_text}
            onChange={handleChange}
        />
    </Box>
    </>
  );
};

export default Comp2Sub;